import { Injectable } from '@angular/core';
import {
    CanActivate,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    UrlTree,
    Router,
} from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import { environment } from 'apps/driver-dashboardfe/src/environments/environment';
import { UserDataService } from '../../services/user-data/user-data.service';

@Injectable({
    providedIn: 'root',
})
export class adminStatusGuard implements CanActivate {
    constructor(
        private authService: AuthenticationService,
        private router: Router,
        private cookieService: CookieService,
        private userDataService: UserDataService
    ) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.checkLoginSession(route);
    }

    checkLoginSession(route: ActivatedRouteSnapshot) {
        let cookieName: any = environment.COOKIE_NAME;
        let adminCookie: any = environment.ADMIN_COOKIE;
        if (route.queryParams['is_admin'] == 'true') {
            // this.cookieService.set(cookieName, '686da8497baae605940b7c5ef9cdb7a629b91069')
            this.cookieService.set(adminCookie, 'yes');
            let token = this.cookieService.get(cookieName);
            if (token) {
                this.authService.setToken(token);
                localStorage.setItem('token', token);
                localStorage.setItem('status', 'Active Driver');
                localStorage.setItem('isAdmin', 'true');
                this.userDataService.fetchUserSummary().subscribe({});
                this.router.navigate(['/dashboard/summary']);
                return true;
            } else {
                this.router.navigate(['/login']);
                return true;
            }
        } else {
            this.router.navigate(['/login']);
            return true;
        }
    }
}
